'use client';

import React from 'react';
import { useTranslation } from '@weareconceptstudio/core';
import { getHomeCategories, getMostWanted } from '@/libs/get-data';

//* Components
import Info from '../components/Info';
import LazyLoadWithData from '@/components/LazyLoadWithData';
import LazySection from '@/components/LazySection';
import Hero from '../components/Hero';
import MostWanted from '../components/MostWanted';
import Categories from '@/modules/_Sections/Categories';
import CashBack from '../../_Sections/CashBack';
import Review from '@/modules/_Sections/Review';
import Faq from '@/modules/_Sections/Faq';

//* Skeleton
import MostWantedSkeleton from '../components/MostWanted/Skeleton';
import CategoriesSkeleton from '@/modules/_Sections/Categories/Skeleton';
import SkeletonSliderReview from '@/modules/_Sections/Review/Skeleton';

//* Style
import HomeTemplateStyle from './style';

const HomeTemplate = ({ pageData }) => {
	const { selectedLang } = useTranslation();

	return (
		<HomeTemplateStyle>
			<Hero data={pageData.hero} />

			<Info data={pageData.info} />

			<LazyLoadWithData
				fetchKey={['most-wanted-products', selectedLang]}
				fetcher={(_, selectedLang) => getMostWanted({ lang: selectedLang })}
				fallback={<MostWantedSkeleton />}>
				{(mostWantedData) => (
					<MostWanted
						data={pageData.most_wanted}
						mostWantedData={mostWantedData}
					/>
				)}
			</LazyLoadWithData>

			<LazyLoadWithData
				fetchKey={['home-categories', selectedLang]}
				fetcher={(_, selectedLang) => getHomeCategories({ lang: selectedLang })}
				fallback={<CategoriesSkeleton />}>
				{(categories) => <Categories categories={categories} />}
			</LazyLoadWithData>

			<CashBack />

			<LazySection
				delay={500}
				fallback={<SkeletonSliderReview />}>
				<Review />
			</LazySection>

			<Faq />
		</HomeTemplateStyle>
	);
};

export default HomeTemplate;
